import React from 'react'
import { useSelector } from 'react-redux'
import AccountingTransactions from 'src/components/AccountingTransactions/AccountingTransactions'
import LayoutShell from 'src/components/LayoutShell/LayoutShell'
import ReceiptToolsLayoutShellButton from 'src/components/ReceiptToolsDropdown/ReceiptToolsLayoutShellButton'
import { SubnavDesign } from 'src/components/Subnav/Subnav'
import { useTranslate } from 'src/localization/Trns'
import { selectUserListModelFromState } from 'src/redux/selectors/auth.selectors'
import {
  selectOrganizationReceiptMgmtEnabledFromState,
  selectUserExplicitOrganizationListModelFromState,
} from 'src/redux/selectors/data/organizations.selectors'

import styles from './AccountingTransactionsShell.style'

const AccountingTransactionsShell: React.FC = () => {
  const translate = useTranslate()

  const user = useSelector(selectUserListModelFromState)
  const organization = useSelector(
    selectUserExplicitOrganizationListModelFromState,
  )
  const receiptManagementEnabled = useSelector(
    selectOrganizationReceiptMgmtEnabledFromState,
  )
  const buttons =
    receiptManagementEnabled && organization !== undefined
      ? [
          <ReceiptToolsLayoutShellButton
            key={'receipt-tools-layout-button'}
            organization={organization}
            hasReceiptRulePermissions={!!user?.hasOrgBookkeeperPermissions}
          />,
        ]
      : []

  return (
    <LayoutShell
      className={'AccountingTransactions'}
      css={styles}
      subnavDesign={SubnavDesign.Floating}
      subnavOptions={[]}
      content={<AccountingTransactions />}
      title={translate('Card Transactions')}
      // subtitle={translate('Confirm spend, receipts, and coding, finalize approvals, and keep your books accurate')}
      buttons={buttons}
    />
  )
}

export default AccountingTransactionsShell
